import type { FaireProductEntity } from "../../entity_types/product";

export const p_4an3jsftpu: FaireProductEntity = {
  token: "p_4an3jsftpu",
  type: "product",
  name: "Bunch of Bears Porcelain Yunomi Tea Cup – 10 oz JP",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/2c7e7cfb543cf626725865db1050bafc58af9ec68f37a34fa7fb32d80e2cfc4b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/238d6c78c6b95fc5a094e337224b7784f3f29a3d6a0cff0d9b7111992d481bbe.jpeg",
    "https://cdn.faire.com/fastly/9112722a18cf622ef1b7fdb450612fd57e537deb9bc38cca106aa43812d36a71.jpeg",
    "https://cdn.faire.com/fastly/6955db168476430783dfcb7a2478716e9f8fdc7b5155ff931efb388b05a90e42.jpeg"
  ],
  priceDollars: 5.5,
  description: "Serve hot green tea the Japanese way with this 10 oz yunomi tea cup in Bunch of Bears. It is decorated with a playful bunch of bears. Made in Japan from durable porcelain, it is built for sushi bars, ramen shops, cafés and Japanese restaurants, while looking just as good at home. A thoughtful gift for tea lovers and bear lovers.\n\nFeatures\n\n * Classic yunomi shape: a tall, handleless cup that is comfortable to hold with both hands \n * Quality porcelain: a classic glazed finish for everyday restaurant and home use \n * Easy care: microwave and dishwasher safe \nSpecifications\n\n * Size: 2.75\" Dia x 4\" H \n * Capacity: 10 fl oz \n * Material: Porcelain \n * Design: Bunch of Bears \n * Inner pack: 6 \n * Case pack: 60 \n * Origin: Japan \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 12.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:55.354Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
